(() => {

  'use strict';

  const root = document.documentElement.dataset.rootUrl || '/';

  let busy = false, opener = null, frame = 0, pendingFocus = null;

  const drawer = () => document.querySelector('#TickeyCartDrawer');

  const form = () => document.querySelector('#tickey-product-form');

  const variants = () => JSON.parse(document.querySelector('[data-tickey-variants]')?.textContent || '[]');

  const selected = () => window.TickeyPacks ? window.TickeyPacks.selected() : variants().find(v => String(v.id) === new FormData(form()).get('id'));

  const protectionConfig=JSON.parse(document.querySelector('#TickeyProtectionConfig')?.textContent||'{}');
  const protection=window.TickeyProtection?.create(protectionConfig,async(path,payload)=>{
    const response=await fetch(root+path,payload?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)}:{headers:{Accept:'application/json'},cache:'no-store'});
    return parse(response);
  });
  let protectionSelected=protectionConfig.initialSelected!==false;
  const paintProtection=()=>document.querySelectorAll('[data-shipping-protection-toggle]').forEach(el=>{el.checked=protectionSelected;});
  async function settleProtection(explicit){
    if(!protection)return;
    const cart=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(parse);
    const state=await protection.sync(cart,explicit);protectionSelected=state.selected;paintProtection();return state;
  }

  const sectionIds = () => ['tickey-cart-drawer', document.querySelector('[data-tickey-cart]')?.dataset.sectionId].filter(Boolean);

  const moneyStatus = (text, error = false) => {

    document.querySelectorAll('[data-drawer-status],[data-cart-message],[data-product-message]').forEach(el => {

      el.textContent = text;

      el.classList.toggle('is-error', error);

    });

  };

  const parse = async response => {

    const data = await response.json();

    if (!response.ok) throw new Error(data.description || data.message || 'We could not update your cart. Please try again.');

    return data;

  };

  const fetchSections = () => fetch(root + '?sections=' + encodeURIComponent(sectionIds().join(',')), {headers:{Accept:'application/json'}, cache:'no-store'}).then(parse);

  function renderSections(sections) {

    const html = sections?.['tickey-cart-drawer'];

    if (!html) throw new Error('Please use View full cart to check your latest items.');

    const parsed = new DOMParser().parseFromString(html, 'text/html');

    const next = parsed.querySelector('[data-drawer-content]');

    if (!next || !drawer()) throw new Error('Please use View full cart to check your latest items.');

    const focused = pendingFocus || document.activeElement;

    const wasUpsell = !!focused?.closest('[data-tickey-accessory]');

    const focusKey = focused?.dataset.lineKey;

    const focusStep = focused?.dataset.cartStep;

    const wasRemove = focused?.hasAttribute('data-cart-remove');

    const wasQuantity = focused?.hasAttribute('data-cart-quantity');

    const scrollTop = drawer().querySelector('.tk-drawer-items')?.scrollTop || 0;

    drawer().querySelector('[data-drawer-content]').replaceWith(next);

    const items = drawer().querySelector('.tk-drawer-items');

    if (items) items.scrollTop = scrollTop;

    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = next.dataset.itemCount);

    paintProtection();
    const page = document.querySelector('[data-tickey-cart]');

    if (page && sections[page.dataset.sectionId]) {

      const fresh = new DOMParser().parseFromString(sections[page.dataset.sectionId], 'text/html').querySelector('[data-tickey-cart]');

      if (fresh) page.replaceWith(fresh);

    }

    if (wasUpsell && drawer().open) {

      (drawer().querySelector('.tk-cart-extra button') || drawer().querySelector('[name="checkout"]') || drawer().querySelector('[data-cart-close]'))?.focus({preventScroll:true});

    }

    if (focusKey) {

      const scope = drawer().open ? drawer() : document.querySelector('[data-tickey-cart]');

      const match = [...(scope?.querySelectorAll('[data-line-key]') || [])].find(el => el.dataset.lineKey === focusKey && (wasRemove ? el.hasAttribute('data-cart-remove') : wasQuantity ? el.hasAttribute('data-cart-quantity') : el.dataset.cartStep === focusStep) && !el.disabled);

      (match || scope?.querySelector('[data-cart-close], [data-cart-remove], h1'))?.focus({preventScroll:true});

    }

  }

  const syncCart = async sections => renderSections(sections?.['tickey-cart-drawer'] && (!document.querySelector('[data-tickey-cart]') || sections[document.querySelector('[data-tickey-cart]').dataset.sectionId]) ? sections : await fetchSections());

  function syncMobile() {

    const bar = document.querySelector('[data-mobile-buy]'), f = form();

    if (!bar || !f) return;

    const variant = selected();

    bar.querySelector('[data-mobile-style-name]').textContent = variant?.title || 'Choose your style';

    bar.querySelector('[data-mobile-price]').textContent = variant?.priceText || '';

    const button = bar.querySelector('[data-mobile-add]');

    const quantity = Number(f.querySelector('[name="quantity"]').value) || 1;

    button.textContent = busy ? 'Updating…' : !variant?.available ? 'Sold out' : quantity > 1 ? `Add ${quantity} sets ↗` : 'Add to cart ↗';

    button.disabled = busy || !variant?.available;

    const style = f.querySelector('.tk-style-options')?.getBoundingClientRect();

    const buy = f.querySelector('.tk-buy-row')?.getBoundingClientRect();

    const inView = rect => rect && rect.bottom > 80 && rect.top < innerHeight - 40;

    bar.hidden = innerWidth > 767 || !!document.querySelector('dialog[open]') || document.querySelector('.tickey-nav')?.classList.contains('is-open') || inView(style) || inView(buy);

  }

  const scheduleMobile = () => {if (!frame) frame = requestAnimationFrame(() => { frame = 0; syncMobile(); });};

  function showDrawer(trigger = document.activeElement) {

    const d = drawer();

    if (!d || !d.showModal) { location.assign(root + 'cart'); return; }

    if (!d.open) {

      opener = trigger;

      d.showModal();

      document.documentElement.classList.add('tk-cart-open');

      d.querySelector('[data-cart-close]').focus({preventScroll:true});

      document.querySelector('.tickey-menu-toggle[aria-expanded="true"]')?.click();

    }

    syncMobile();

  }

  function closeDrawer() {

    drawer()?.close();

    document.documentElement.classList.remove('tk-cart-open');

    syncMobile();

    const target = opener?.isConnected && opener.getClientRects().length ? opener : document.querySelector('.tk-header-cart');

    target?.focus({preventScroll:true});

  }

  const refreshDrawer = async trigger => {

    if (busy) { showDrawer(trigger); return; }

    busy = true;

    showDrawer(trigger);

    moneyStatus('Updating your cart…');

    const restore = lockControls();

    try { await settleProtection(); await syncCart(); paintProtection(); moneyStatus(''); }

    catch (error) { moneyStatus(error.message, true); }

    finally { busy = false; restore(); syncMobile(); }

  };

  function lockControls() {

    pendingFocus = document.activeElement;

    const elements = [...document.querySelectorAll('[data-shipping-protection-toggle],[data-tickey-accessory] button[type="submit"],[data-cart-step],[data-cart-quantity],button[data-cart-remove],[data-add-to-cart],[data-quantity-minus],[data-quantity-plus],[data-style-input],[data-pack-style],[name="pack_size"],#tk-quantity,.tk-drawer [name="checkout"],#tickey-cart-form [name="checkout"]')];

    const states = elements.map(el => [el, el.disabled]);

    elements.forEach(el => {el.disabled = true;});

    document.querySelectorAll('[data-drawer-content],[data-tickey-cart]').forEach(el=>el.setAttribute('aria-busy','true'));

    syncMobile();

    return () => {

      states.forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });

      document.querySelectorAll('[data-drawer-content],[data-tickey-cart]').forEach(el=>el.removeAttribute('aria-busy'));

      const add = form()?.querySelector('[data-add-to-cart]');

      if (add) {add.disabled = !selected()?.available; add.removeAttribute('aria-busy'); add.textContent = selected()?.available ? 'Add to cart →' : 'Sold out';}

      pendingFocus = null;

    };

  }

  async function setProtectionChoice(selected){
    if(busy){paintProtection();return;}
    busy=true;const restore=lockControls();
    try{await settleProtection(selected);await syncCart();paintProtection();moneyStatus('');}
    catch(error){paintProtection();moneyStatus(error.message,true);}
    finally{busy=false;restore();paintProtection();}
  }

  async function mutate(path, payload, success, trigger) {

    if (busy) return;

    busy = true;

    const restore = lockControls();

    moneyStatus(path === 'cart/add.js' ? 'Adding to your cart…' : 'Updating cart…');

    let committed = false;

    try {

      const result = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload, sections:sectionIds(), sections_url:location.pathname})}).then(parse);

      committed = true;

      if (path === 'cart/add.js') showDrawer(trigger);

      await settleProtection();
      await syncCart();
      paintProtection();

      moneyStatus(success);

    } catch (error) {

      // Shopify may clamp quantity even when it returns an inventory error.

      try {await syncCart();} catch { /* Keep the full-cart fallback available. */ }

      if (path === 'cart/add.js') showDrawer(trigger);

      moneyStatus(committed ? 'Your change was saved. Please use View full cart to check the latest cart.' : error.message, true);

    } finally {

      busy = false;

      restore();

      syncMobile();

    }

  }

  document.addEventListener('submit', e => {
    if(e.submitter?.name==='checkout'&&(e.target.closest('#TickeyCartDrawer')||e.target.id==='tickey-cart-form')){
      e.preventDefault();if(busy)return;
      if(protectionConfig.reviewOnly){moneyStatus('This review preview is not ready for checkout.',true);return;}
      busy=true;const restore=lockControls();
      settleProtection().then(()=>location.assign(root+'checkout')).catch(error=>moneyStatus(error.message,true)).finally(()=>{busy=false;restore();paintProtection();});return;
    }


    if (e.target.matches('[data-tickey-accessory]')) {

      e.preventDefault();

      if (busy || !e.target.reportValidity()) return;

      const id = Number(new FormData(e.target).get('id'));

      if (!Number.isSafeInteger(id) || id < 1) return;

      mutate('cart/add.js', {items:[{id,quantity:1}]}, 'Accessory added to your bag.', document.activeElement);

      return;

    }

    // Product option inputs named "id" shadow HTMLFormElement.id.

    if (!e.target.matches('#tickey-product-form')) return;

    e.preventDefault();

    if (busy || !e.target.reportValidity()) return;

    const variant = selected(), quantity = Number(e.target.querySelector('[name="quantity"]').value);

    if (!variant?.available || !Number.isInteger(quantity) || quantity < 1) return;

    mutate('cart/add.js', {items:[{id:variant.id,quantity}]}, `${quantity} × ${variant.title} added.`, document.activeElement);

  });

  document.addEventListener('click', e => {

    const target = e.target.closest('button,a');

    if (!target) return;

    if (target.matches('[data-home-link]') && location.pathname === root) {

      e.preventDefault();

      window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});

      const u = new URL(location.href);u.hash='';history.replaceState({},'',u);

      return;

    }

    if (target.matches('[data-cart-close]')) {closeDrawer();return;}

    if (target.matches('[data-continue-shopping]') && form()) {e.preventDefault();closeDrawer();return;}

    if (target.matches('[data-mobile-style]')) {

      form()?.querySelector('.tk-style-options')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});

      return;

    }

    if (target.matches('[data-mobile-add]')) {form()?.requestSubmit();return;}

    if (target.matches('[data-quantity-minus],[data-quantity-plus]') && form()) {

      const input = form().querySelector('[name="quantity"]');

      input.value = Math.max(1,(parseInt(input.value,10)||1)+(target.hasAttribute('data-quantity-plus')?1:-1));syncMobile();return;

    }

    if (target.matches('[data-cart-step],[data-cart-remove]')) {

      e.preventDefault();

      if (busy) return;

      const removing = target.hasAttribute('data-cart-remove');
      if(removing&&target.hasAttribute('data-protection-remove')){setProtectionChoice(false);return;}

      const quantity = removing ? 0 : Math.max(1,Number(target.dataset.quantity) + Number(target.dataset.cartStep));

      mutate('cart/change.js',{id:target.dataset.lineKey,quantity},removing?'Item removed.':'Cart updated.');return;

    }

    if (target.matches('a[href]') && !target.hasAttribute('data-cart-page') && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) {

      const url = new URL(target.href, location.href);

      if (url.origin === location.origin && url.pathname.replace(/\/$/,'') === (root+'cart').replace(/\/$/,'') && !url.search) {e.preventDefault();refreshDrawer(target);}

    }

    scheduleMobile();

  });

  document.addEventListener('change', e => {
    if(e.target.matches('[data-shipping-protection-toggle]')){
      if(busy){paintProtection();return;}
      setProtectionChoice(e.target.checked);return;
    }


    if (e.target.matches('[data-cart-quantity]') && e.target.reportValidity()) {

      const quantity = Number(e.target.value);

      if (Number.isInteger(quantity) && quantity >= 0) mutate('cart/change.js',{id:e.target.dataset.lineKey,quantity},'Cart updated.');

    }

    scheduleMobile();

  });

  document.addEventListener('input', scheduleMobile);

  document.addEventListener('tickey:pack-change', scheduleMobile);

  document.addEventListener('cancel', e => {if (e.target.id === 'TickeyCartDrawer') {e.preventDefault();closeDrawer();}},true);

  document.addEventListener('click', e => {

    if (e.target !== drawer()) return;

    const r = e.target.getBoundingClientRect();

    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDrawer();

  });

  window.addEventListener('scroll',scheduleMobile,{passive:true});

  window.addEventListener('resize',scheduleMobile);

  window.addEventListener('popstate',scheduleMobile);

  window.addEventListener('pageshow', e => {if (e.persisted) syncCart().catch(()=>{});scheduleMobile();});

  document.addEventListener('shopify:section:load',scheduleMobile);

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded',()=>{scheduleMobile();paintProtection();if(!protectionConfig.reviewOnly&&document.querySelector('[data-tickey-cart]'))setProtectionChoice();},{once:true}) : (scheduleMobile(),paintProtection(),!protectionConfig.reviewOnly&&document.querySelector('[data-tickey-cart]')&&setProtectionChoice());

})();

